<h5 i18n>Customer Reviews</h5>
<!--//the stars will be here-->
<div class="pt-4 pb-4">
    Review this product
    Share your thoughts with other customers<br>
    <button (click)="openNewReviewCommentDialog()" class="btn btn-primary mt-4">Write a review</button>
</div>
<mat-divider></mat-divider>

<div *ngIf="reviews?.length == 0">
    No Reviews added yet.
</div>

<div  *ngFor="let review of reviews">
    <app-review-comment [review]="review"></app-review-comment>

</div>
